import { useMediaQuery } from './use-media-query';

export const useIsMobile = () => {
  const isDesktop = useMediaQuery('(min-width: 960px)');

  return {
    isDesktop,
    isMobile: !isDesktop,
  };
};
